<template>
  <div>

    <template v-if="$route.name == 'serialNumber'">

    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
      @search="getTableData"
    ></ots-table-group-new>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { serialGetSelectClassAPI, exportSerialNumberAPI, serialQueryListAPI } from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportInfo,
        },
      ],
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '教室名称',
          type: 'select',
          requestKey: 'classId',
          label: 'name',
          value: 'id',
          data: [],
        },        
      ],
      pagination: {
        total: 0,
      },
      tableData: [],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "考点名称",
          prop: "placeName",
        },
        {
          title: "教室名称",
          prop: "className",
        },
        {
          title: "序列号查询",
          prop: "serialNumber",
        },
        {
          title: "序列号是否使用",
          prop: "isUsed",
        },
        {
          title: "注册机器码",
          prop: "machineCode",
        },
        {
          title: "注册时间",
          prop: "registerTime",
        },
        {
            title: '操作',
            type:"buttons",
            width:"80",
            btnList:[
              {
                title: "考试机查询",
                click: this.queryMachine,
              }
            ]
        },
      ],
      requestForm: {
        planId: '',
        placeId: '',
        classId: '',
        size: 10,
        page: 1,
      },
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
      this.getTableData();
    },
    'requestForm.placeId': function(value) {
      this.getClass();
    },
  },
  created() {
    this.getPlan();
  },
  methods: {
    // 获取批次
    async getPlan() {
      const { data: planData } = await getSelectPlanFn();
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },

    // 获取考点
    async getPlace(value) {
      const { data: placeData } = await getCurrentSelectPlace({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },

    // 获取教室
    async getClass() {
      let params = {
        planId: this.requestForm.planId,
        placeId: this.requestForm.placeId
      }
      const { data: classData } = await serialGetSelectClassAPI(params);
      if (classData.length === 0) {
        this.selectList[2].data = [];
        this.requestForm.classId = '';
        return;
      }
 
      this.selectList[2].data = [{id: '', name: '全部'}, ...classData];
      this.requestForm.classId = '';
    },

    // 获取表格数据
    async getTableData() {
      let params = { ...this.requestForm }
      const { data: tableData } = await serialQueryListAPI(params);
      this.pagination.total = tableData.total;
      this.tableData = tableData.records;
    },

    // 导出
    async exportInfo() {
      let params = { ...this.requestForm };
      let result = await exportSerialNumberAPI(params)
      if (result.code === 1) {
        window.open(result.data);
      }
    },

    // 查询考试机
    queryMachine(row) {
      this.$router.push({
        name:'queryMachine',
        query: row
      })
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }

}
</script>
